import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { GetSingleSurveyFromBankProps } from ".";

export function useGetSingleSurveyFromBank({ surveyId }: GetSingleSurveyFromBankProps) {
    return useQuery({
        ...queryKeys.survey_bank.details({ surveyId }),
        enabled: !!surveyId,
    });
}
